import React from 'react'
import moment from 'moment'

export const assetsViewLayoutTypes = { TILE: 0,  LIST: 1 }
export const imageAssetTypes = ['png', 'jpg', 'jpeg', 'gif', 'svg']

export const keyState = { cmdActive: false, ctrlActive: false }

document.addEventListener('keydown', evt => {
    if (evt.key === 'Meta') {
        keyState.cmdActive = true;
    }
    if (evt.key === 'Control') {
        keyState.ctrlActive = true;
    }
})

document.addEventListener('keyup', evt => {
    if (evt.key === 'Meta') {
        keyState.cmdActive = false;
    }
    if (evt.key === 'Control') {
        keyState.ctrlActive = false;
    }
})

export const getQueryParams = () => new URLSearchParams((new URL(window.location.href)).search);

export function transformAssetList (assets) {
    return assets.map(asset => {
        const pathParts = asset.uri.split('/')
        const parentDirs = pathParts.slice(0, pathParts.length - 1)
        const parentDir = parentDirs.join('/')
        const name = (asset.type === 'directory' ? '/' : '').concat(pathParts[pathParts.length - 1])

        return {
            ...asset,
            parentDir,
            name
        }
    })
}

const Timestamp = ({ date }) => {
    const d = moment(date);
    const topStyle = { padding: '1px 2px' }
    const bottomStyle = { ...topStyle, opacity: 0.5 }
    return (
        <React.Fragment>
            <span style={topStyle}>{d.format('M/D/YY')} {d.format('h:mm a')}</span>
            <span style={bottomStyle}>{d.fromNow()}</span>
        </React.Fragment>
    )
}


export function getAssetAttributes (asset, wide) {
    const kb = (asset.size / 1000).toFixed(2);
    const mb = kb >= 1000 ? (kb / 1000).toFixed(2) : null;

    return [
        { label: 'File size', value: mb ? `${mb} MB` : `${kb} KB` },
        { label: 'Created', value: <Timestamp date={asset.created}/> },
        { label: 'Modified', value: <Timestamp date={asset.modified}/> }
    ];
}

export function getIconForAsset (asset) {
    switch (asset.type.toLowerCase()) {
        case 'directory':
            return asset.name.indexOf('.') === 0
                ? 'folder-open-o'
                : 'folder-open manilla';

        case 'jpg':
        case 'jpeg':
        case 'webm':
        case 'gif':
        case 'png':
        case 'svg':
            return 'file-image-o'

        case 'zip':
        case 'tar':
        case 'tgz':
        case 'gzip':
        case 'gz':
            return 'file-archive-o'

        case 'aac':
        case 'wav':
        case 'mp3':
        case 'm3u':
        case 'flac':
        case 'ogg':
            return 'file-audio-o'

        case 'js':
        case 'xml':
        case 'html':
        case 'css':
        case 'scss':
        case 'jsx':
        case 'json':
        case 'sass':
        case 'less':
        case 'cs':
        case 'php':
        case 'yaml':
            return 'file-code-o'

        case 'xls':
        case 'csv':
        case 'xlsx':
            return 'file-excel-o'

        case 'pdf':
            return 'file-pdf-o'

        case 'ppt':
        case 'pptx':
            return 'file-powerpoint-o'

        case 'txt':
        case 'rtf':
        case 'md':
        case 'epub':
            return 'file-text-o'

        case 'mp4':
        case 'mov':
        case 'mpv':
        case 'webm':
        case 'wmv':
            return 'file-video-o'

        case 'doc':
        case 'docx':
            return 'file-word'

        default:
            return 'file-o'
    }
}

export function setQueryParam (key, value) {
    const queryParams = (new URLSearchParams(window.location.search));

    queryParams.set(key, value);

    const baseUrl = window.location.protocol.concat('//', window.location.host, window.location.pathname)
    const fullUrl = baseUrl.concat('?', queryParams.toString())

    window.history.pushState({ path: fullUrl }, '', fullUrl);
}



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/Assets/assets-utils.jsx